export default `return (length(vec2((length(vec2(length(p.xy)-1.3,
      length(p.zy)-1.3))-.5), dot(cos(p*12.),sin(p.zxy*12.))*.1))-.02)*.3;
  }`